
export const routes = (prefix = `master-data`) => [
    {
        path: `/${prefix}/accounts/shelves`,
        name: `${prefix}.accounts.shelves.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.accounts.shelves.index`,
                PageDescription: "Accounts master data: Shelves",
            },
        },
    },
];
